import client from "src/api/client";
import type { NestGetPartnersParams } from "src/api/interfaces/nest/api";
import { useAsyncFetcher } from "./useAsyncFetcher";

export const useNestPartnersFetcher = (
  params: NestGetPartnersParams,
  shouldSearch: (countryCode: string, partnerCode: string) => boolean
) => {
  return useAsyncFetcher<string[]>(
    async () => {
      const response = await client.getNestPartners(params);
      return response.partnerCodes;
    },
    [],
    [params.countryCode, params.partnerCode, params.limit],
    shouldSearch(params.countryCode, params.partnerCode),
    400
  );
};
